import {getCurrencySymbol} from '@/helper';

const currencySymbol = {
  methods: {
    getCurrencySymbol (currency) {
      return getCurrencySymbol (currency);
    },
  },
};

export {currencySymbol};
